import { IComponentOptions } from "angular";
import dayjs from "@gtmhub/dayjs";
import { Task } from "@webapp/tasks/models/tasks.models";

interface ITaskCardBindings {
  task: Task;
  setDueDate(): void;
  archive(): void;
  clone(): void;
  deleteTask(): void;
}

class TaskCardCtrl implements ITaskCardBindings {
  public setDueDate: () => void;
  public archive: () => void;
  public clone: () => void;
  public deleteTask: () => void;
  public task: Task;

  public dueDateChanged(date: string): void {
    this.task.dueDate = dayjs(date).toISOString();
    this.setDueDate();
  }
}

export const TaskCardComponent: IComponentOptions = {
  template: require("./task-card.html"),
  controller: TaskCardCtrl,
  bindings: {
    task: "<?",
    setDueDate: "&?",
    archive: "&?",
    clone: "&?",
    deleteTask: "&?",
  },
};
